<template>

    <div>
        <span class="alarmeJeObjektkategorie" v-if="chartdata">
           <horizontal-bar-chart
                   v-if="loaded"
                   v-on:set-chart="setChart"
                   :chartdata="chartdata"
                   :options="options" />
        </span>
        <div v-else-if="!chartdata && !loaded" class="text-center">
            <SpinnerImage />
        </div>
    </div>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true
    import HorizontalBarChart from '@/components/charts/HorizontalBarChart'
    import SpinnerImage from '@/components/layout/SpinnerImage'
    import bootbox from 'bootbox'

    export default {
      name: 'BarChartAlarmeJeObjektkategorie',
      components: {
        HorizontalBarChart,
        SpinnerImage
      },
      props: ['besuchsbericht', 'customer', 'keyUser', 'subUser', 'filter', 'auftrag'],
      data () {
        return {
          loaded: false,
          /** Daten für den Bar Chart */
          chartdata: null,
          options: null,
          /** Chart.js Chart */
          chart: null,
          /** Filter der Charts */
          filterung: {
            /** Filter nach einer Objektkategorie */
            filterObjektkategorie: null,
            /** Filter nach einer Area */
            filterArea: null
          }
        }
      },
      watch: {
        besuchsbericht: function () {
          this.init()
        },
        customer: function () {
          this.init()
        },
        keyUser: function () {
          this.init()
        },
        filter: {
          handler: function (newObj) {
            console.log('Filter in BarChartAlarmeJeObjektkategorie geändert', newObj)
            this.filterung = newObj
            this.init()
          },
          deep: true
        },
        subUser: function () {
          this.init()
        }
      },
      created () {
        this.init()
      },
      methods: {

        /**
         * Chart des Parents zurückliefern um Klick Events zu behandeln
         */
        setChart: function (obj) {
          console.log("set chart: " + obj);
          this.chart = obj;
        },
        /**
         * Klick auf den Chart, Filter setzen
         * @param event click Event
         */
        chartClickEvent: function (event) {

          console.log('chartClickEvent ' + event)
          var elements = this.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true)
          if (elements && elements.length > 0) {
            var idx = elements[0].index
            console.log('index = ' + idx)
            var label = this.chart.config.data.labels[idx]
            console.log('label = ' + label)
            if (label == 'Mängel') {
              bootbox.alert(this.$t('message.bar_chart_alarme_je_objektkategorie_maengel'))
              return
            }
            if (label) {
              this.filterObjektkategorie(label)
            }
          }

        },
        /**
         * nach einer Objektkategorie filtern
         * @param label Objekttyp Bezeichnung
         */
        filterObjektkategorie: function (label) {

          if (label) {
            console.log('Filter Objektkategorie gesetzt: ' + label);
            this.filterung.filterObjektkategorie = label;
            this.$emit('filter-objektkategorie', label);
          }

        },
        init: async function () {

          const that = this
          this.options = {
            onClick: this.chartClickEvent,
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              title: {
                display: true,
                text: this.$t('message.charts_alarme_je_objektkategorie')
              },
              tooltip: {
                callbacks: {

                  label: function (ctx) {

                    console.log('tooltip ctx:', ctx)
                    let label = ctx.dataset.label || '';
                    if (ctx.label == 'Mängel') {
                      let l = that.$t('message.customerNotifications_prioritaet') + ' '
                      if (label == 'OK')           l += that.$t('message.editMangelPrioritaet_gering')
                      else if (label == 'Warnung') l += that.$t('message.editMangelPrioritaet_mittel')
                      else if (label == 'Gefahr')  l += that.$t('message.editMangelPrioritaet_hoch')
                      else l = null
                      if (l) {
                        label = l + ': ' + ctx.parsed.x + ' %'
                      }
                    } else {
                      if (label) {
                        label += ': ' + ctx.parsed.x + ' %';
                      }
                    }
                    return label

                  }

                }
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: true,
                ticks: {
                  callback: function (value) { if (Number.isInteger(value)) { return value + '%'; } },
                  stepSize: 10
                }
              },
              y: {
                stacked: true
              }
            }
          }

          // Chart nicht anzeigen wenn z. B. keine Einzelaufträge angezeigt werden sollen,
          // aber derzeit ein Einzelauftrag ausgewählt wurde,
          // das gleiche für Monitoringaufträge
          if (this.filter && this.filter.auftragsart && this.besuchsbericht && this.auftrag && this.auftrag.herkunft) {

            if (
                (this.auftrag.herkunft == 'Servicevertrag'        && this.filter.auftragsart.monitoringbesuch == 'false') ||
                (this.auftrag.herkunft == 'Einzelauftrag'         && this.filter.auftragsart.einzelauftrag == 'false')    ||
                (this.filter.auftragsart.einzelauftrag == 'false' && this.filter.auftragsart.monitoringbesuch == 'false')
            ) {
              console.log('Chart BarChartAlarmeJeObjektkategorie nicht anzeigen da Serviceverträge gefiltert sind.')
              this.chartdata = null
              this.loaded    = true
              return
            }

          }

          if (this.customer) this.$store.commit('setChartAvailableBarChartAlarmeJeObjektkategorie', true)
          this.loaded = false
          this.chartdata = null
          if (this.besuchsbericht || this.customer || this.keyUser || this.subUser) {

            // ein SubUser kann ein normaler SubUser oder ein KeyUser sein der von einem anderen KeyUser hinzugefügt wurde
            let subUserId = null
            if (this.keyUser) {
              subUserId = this.keyUser.id
            } else if (this.subUser) {
              subUserId = this.subUser.id
            }

            // ich brauche hier die Areas von allen Standorten des Benutzers:
            let areasAllowed = null
            if (this.$store.getters.showAreas && this.$store.getters.showAreas.length > 0) {
              areasAllowed = this.$store.getters.showAreas.join(',')
            }

            const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getChartDataOfBesuchsbericht'
            const params  = {
              besuchsbericht_id:      this.besuchsbericht ? this.besuchsbericht.id : null,
              customer_id:            this.customer ? this.customer.id : null,
              key_user_id:            this.keyUser ? this.keyUser.keyUserId : null,
              sub_user_id:            subUserId,
              mandant:                this.keyUser ? this.keyUser.biotechCountry.name : null,
              type:                   'BAR_CHART_ALARME_JE_OBJEKTKATEGORIE',
              filterArea:             this.filterung ? this.filterung.filterArea : null,
              filterObjektkategorie:  this.filterung ? this.filterung.filterObjektkategorie : null,
              areasAllowed:           areasAllowed,
              auftragsart:            this.filterung ? JSON.stringify(this.filterung.auftragsart) : null,
            }

            await axios({
              method: 'GET',
              params: params,
              url: url,
            }).then(function (response) {

              if (response.data) {

                that.chartdata = response.data.chartdata
                if (that.chartdata) {

                  var datasets = that.chartdata.datasets
                  if (datasets) {

                    // prüfe ob Ergebnisse vorhanden, sonst nicht anzeigen:
                    let result = false
                    for (var i = 0; i < datasets.length; i++) {
                      const dataset = datasets[i]
                      if (dataset.data && dataset.data.length > 0) {
                        result = true
                        break
                      }
                    }
                    if (result) {
                      console.log('alarme je objektkategorie verfübar.')
                      if (that.customer) that.$store.commit('setChartAvailableBarChartAlarmeJeObjektkategorie', true)
                    } else {
                      that.chartdata = null
                      if (that.customer) that.$store.commit('setChartAvailableBarChartAlarmeJeObjektkategorie', false)
                    }

                    if (response.data.dataStart) {
                      // setze Title des Charts
                      that.options.plugins.title.text = that.$t('message.charts_alarme_je_objektkategorie_seit') + that.javaDateToDefaultDateFormat(response.data.dataStart)
                    }

                  } else {
                    that.chartdata = null
                  }

                } // end if that.chartdata

              }
              that.loaded = true

            }).catch(error => {
              console.log(error)
              that.loaded = true
            })
          }

        }

      }

    }

</script>
